import React, { useEffect, useState } from "react";
import { ValidationMessage } from "../../components/Utils";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { TIMER_EDIT, TIMER_UPDATE } from "../../routes/routes";
import { toast } from "react-toastify";
import { FullPageLoader } from "../../components/common/Loader"; // Import the loader component
import { TIMER_UPDATED } from "../../constant/constant";

const TimerEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState();
  const [errors, setErrors] = useState({});

  /**   *
   * @param {*} input
   * @param {*} callback
   */

  const submit = () => {
    setBtnDisabled(true);
    let requestBody = { ...form };
    axios
      .put(TIMER_UPDATE + id, requestBody)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(TIMER_UPDATED);
          navigate("/timers");
        }
      })
      .catch((err) => {
        if (err.response.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        }
      })
      .finally(() => {
        setBtnDisabled(false);
      });
  };
  useEffect(() => {
    axios
      .get(TIMER_EDIT + id)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          let responseData = res.data.data;
          setForm({
            id: responseData?.id,
            title: responseData?.title,
            subtitle: responseData?.subtitle,
            // icon: responseData?.icon,
            duration_seconds: responseData?.duration_seconds,
            status: responseData?.status,
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);
  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Timers</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <Link to={"/timers"}>
                    <span>Timers List</span>
                  </Link>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Edit Timer</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/timers"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                {/* <h5 className="mb-0">Edit Timer</h5> */}
              </div>
              <div className="card-body">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="title">
                          Timer Title<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="title"
                          placeholder="Title"
                          onChange={(e) =>
                            setForm({ ...form, title: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, title: e.target.value })
                          }
                          defaultValue={form?.title}
                        />
                        <ValidationMessage error={errors} name="title" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="subtitle">
                          Timer SubTitle<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="subtitle"
                          placeholder="Sub Title"
                          onChange={(e) =>
                            setForm({ ...form, subtitle: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, subtitle: e.target.value })
                          }
                          defaultValue={form?.subtitle}
                        />
                        <ValidationMessage error={errors} name="subtitle" />
                      </div>
                    </div>

                    {/* <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="icon"
                        >
                          Timer Icon<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="icon"
                          placeholder="Icon"
                          onChange={(e) =>
                            setForm({ ...form, icon: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, icon: e.target.value })
                          }
                          defaultValue={form?.icon}
                        />
                        <ValidationMessage error={errors} name="icon" />
                      </div>
                    </div> */}

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="duration_seconds"
                        >
                          Duration in Seconds
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="duration_seconds"
                          placeholder="Duration in Seconds"
                          onChange={(e) =>
                            setForm({
                              ...form,
                              duration_seconds: e.target.value,
                            })
                          }
                          onBlur={(e) =>
                            setForm({
                              ...form,
                              duration_seconds: e.target.value,
                            })
                          }
                          defaultValue={form?.duration_seconds}
                        />
                        <ValidationMessage
                          error={errors}
                          name="duration_seconds"
                        />
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/timers"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="submit"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimerEdit;
